import { kevinAuthAPI } from 'apis/config';

export const assetsApis = {
  assetsList: (type) =>
    kevinAuthAPI.get(`/asset-stock/${type}`).then((res) => res.data),
  assetsUpload: (type: string, data) =>
    kevinAuthAPI
      .post(`/asset-stock/${type}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  assetsDelete: (type, id) =>
    kevinAuthAPI.delete(`/asset-stock/${type}/${id}`).then((res) => res.data),
  assetsUpdate: (type, id, data) =>
    kevinAuthAPI
      .put(`/asset-stock/${type}/${id}`, data)
      .then((res) => res.data),
  assetsUpdateImage: (type, id, data) =>
    kevinAuthAPI
      .patch(`/asset-stock/${type}/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
};
